module.exports = __webpack_public_path__ + "static/media/5ed7a40472f4e5e57a74878e.8e9f3af3.png";